import { storageSession } from '@/utils/storage';
import { mapMutations } from 'vuex';

export default {
  name: 'ProfileOrderPromo',
  components: {},
  props: {},
  emits: [],
  data() {
    return {};
  },
  watch: {},
  created() {
    storageSession.setItem('profileOrderPromo', true);
  },
  mounted() {},
  computed: {},
  methods: {
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    onGoProfilePromocode() {
      this.modalClose('profileOrderPromo');
      if (this.$route.name !== 'profile-promo') {
        this.$router.push({ name: 'profile-promo' }).catch(() => {});
      }
    }
  },
  unmounted() {}
};
